import { ElMessage } from 'element-plus';

// /// 显示可复制的消息
// export function showCopiableMessage(messenger, msg, textToCopy, timeout = 5000) {
//     messenger({
//         dangerouslyUseHTMLString: true,
//         message: `<div><span>${msg}</span><a id="copyTraNo" href='#' style='color: #11bec1; margin-left: 20px;'>复制</a></div>`,
//         type: 'success',
//         duration: timeout
//     });
//     document.getElementById('copyTraNo').addEventListener('click', () => {
//         copyText(messenger, textToCopy);
//     });
// }

export function copyText(textToCopy) {
    if (textToCopy) {
        const input = document.createElement('input');
        input.type = 'text';
        input.value = textToCopy.trim();
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
        ElMessage.success(`‘${input.value}’复制成功`);
    }
}
